import { NEWBUILDING_BUILDER_CALL_REASONS } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentGroup } from '../../utils/experiments';

/**
 * TODO: Удалить файл после раскатки эксперимента в CD-164235
 */
export const selectBuilderCallExperimentActive = (state: IApplicationState) => {
  const { abUseExperiments } = state;

  return isAbUseExperimentGroup(abUseExperiments, NEWBUILDING_BUILDER_CALL_REASONS, 'enabled');
};
